// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login{
       
        padding-top: 200px;
        padding-bottom: 80px;
        background-color: rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
}

.login-card{
        width: 60%;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: left;
        border-radius: 10px;
        padding: 50px;
}

.login-card h1{
    font-family: 'Poppins', sans-serif;
    font-weight: 520;
}

.login-form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
}

.login-form input{
        height: 50px;
        margin-bottom: 20px;
        width: 90%;
        font-size: large;
        font-family: 'Poppins', sans-serif;
        font-weight: 100;
        padding-left: 20px;
}


/* #F9C12E */

.login-page-button{
        height: 50px;
        width: 200px;
        background-color: #e42727;
        border: none;
        font-size: large;
        font-family: 'Poppins', sans-serif;
        margin-bottom: 20px;
        border-radius: 5px;
        color:#fff;
        cursor: pointer;
                position: relative;
                overflow: hidden;
                z-index: 0;
}

.login-page-button::after {
        /* this is what all  will be done when mouse outs from the button */
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: #ffa406;
        z-index: -1;
        border-radius: 5px;
        transition: 0.3s ease all;
        transform: scale(0, 1);

        /* this is you are to change for diffirent transition; */

        transform-origin: bottom left;
        transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.login-page-button:hover::after {
        transform: scale(1, 1);
        transform-origin: top left;
}



.login-form a{
        font-family: 'Poppins', sans-serif;
        font-size: medium;
}

.login-form-navigation a{
    margin-right:50px;
}

@media  screen and (max-width:768px){
        .login {
                        padding-top: 180px;
                        padding-bottom: 20px;
                        background-color: rgba(0, 0, 0, 0.1);
                        display: flex;
                        justify-content: center;
                }
        .login-form-navigation{
                display: flex;
                flex-direction: column;
                align-items:center;
        }
        .login-form-navigation{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
        } 
        .login-form-navigation a{
                margin-right:0px;
        }
                .login-card {
                        width: 80%;
                        background-color: #fff;
                        display: flex;
                        flex-direction: column;
                        justify-content: left;
                        align-items: left;
                        border-radius: 10px;
                        padding: 20px;
                }
                .login-form input {
                        height: 50px;
                        margin-bottom: 10px;
                        width: 90%;
                        font-size: large;
                        font-family: 'Poppins', sans-serif;
                        font-weight: 100;
                        padding-left: 20px;
                        margin-top: 10px;
                }
                .login-card h1 {
                        font-family: 'Poppins', sans-serif;
                        font-weight: 520;
                        margin:20px;
                }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Login.css"],"names":[],"mappings":"AAAA;;QAEQ,kBAAkB;QAClB,oBAAoB;QACpB,oCAAoC;QACpC,aAAa;QACb,uBAAuB;AAC/B;;AAEA;QACQ,UAAU;QACV,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,qBAAqB;QACrB,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;AAC3B;;AAEA;QACQ,YAAY;QACZ,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,kCAAkC;QAClC,gBAAgB;QAChB,kBAAkB;AAC1B;;;AAGA,YAAY;;AAEZ;QACQ,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,kCAAkC;QAClC,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV,eAAe;gBACP,kBAAkB;gBAClB,gBAAgB;gBAChB,UAAU;AAC1B;;AAEA;QACQ,mEAAmE;QACnE,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,sBAAsB;;QAEtB,wDAAwD;;QAExD,6BAA6B;QAC7B,0DAA0D;QAC1D,0DAA0D;AAClE;;;;AAIA;QACQ,sBAAsB;QACtB,0BAA0B;AAClC;;;;AAIA;QACQ,kCAAkC;QAClC,iBAAiB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;QACQ;wBACgB,kBAAkB;wBAClB,oBAAoB;wBACpB,oCAAoC;wBACpC,aAAa;wBACb,uBAAuB;gBAC/B;QACR;gBACQ,aAAa;gBACb,sBAAsB;gBACtB,kBAAkB;QAC1B;QACA;gBACQ,aAAa;gBACb,sBAAsB;gBACtB,mBAAmB;gBACnB,uBAAuB;QAC/B;QACA;gBACQ,gBAAgB;QACxB;gBACQ;wBACQ,UAAU;wBACV,sBAAsB;wBACtB,aAAa;wBACb,sBAAsB;wBACtB,qBAAqB;wBACrB,iBAAiB;wBACjB,mBAAmB;wBACnB,aAAa;gBACrB;gBACA;wBACQ,YAAY;wBACZ,mBAAmB;wBACnB,UAAU;wBACV,gBAAgB;wBAChB,kCAAkC;wBAClC,gBAAgB;wBAChB,kBAAkB;wBAClB,gBAAgB;gBACxB;gBACA;wBACQ,kCAAkC;wBAClC,gBAAgB;wBAChB,WAAW;gBACnB;AAChB","sourcesContent":[".login{\n       \n        padding-top: 200px;\n        padding-bottom: 80px;\n        background-color: rgba(0, 0, 0, 0.1);\n        display: flex;\n        justify-content: center;\n}\n\n.login-card{\n        width: 60%;\n        background-color: #fff;\n        display: flex;\n        flex-direction: column;\n        justify-content: left;\n        align-items: left;\n        border-radius: 10px;\n        padding: 50px;\n}\n\n.login-card h1{\n    font-family: 'Poppins', sans-serif;\n    font-weight: 520;\n}\n\n.login-form {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n}\n\n.login-form input{\n        height: 50px;\n        margin-bottom: 20px;\n        width: 90%;\n        font-size: large;\n        font-family: 'Poppins', sans-serif;\n        font-weight: 100;\n        padding-left: 20px;\n}\n\n\n/* #F9C12E */\n\n.login-page-button{\n        height: 50px;\n        width: 200px;\n        background-color: #e42727;\n        border: none;\n        font-size: large;\n        font-family: 'Poppins', sans-serif;\n        margin-bottom: 20px;\n        border-radius: 5px;\n        color:#fff;\n        cursor: pointer;\n                position: relative;\n                overflow: hidden;\n                z-index: 0;\n}\n\n.login-page-button::after {\n        /* this is what all  will be done when mouse outs from the button */\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        background-color: #ffa406;\n        z-index: -1;\n        border-radius: 5px;\n        transition: 0.3s ease all;\n        transform: scale(0, 1);\n\n        /* this is you are to change for diffirent transition; */\n\n        transform-origin: bottom left;\n        transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.login-page-button:hover::after {\n        transform: scale(1, 1);\n        transform-origin: top left;\n}\n\n\n\n.login-form a{\n        font-family: 'Poppins', sans-serif;\n        font-size: medium;\n}\n\n.login-form-navigation a{\n    margin-right:50px;\n}\n\n@media  screen and (max-width:768px){\n        .login {\n                        padding-top: 180px;\n                        padding-bottom: 20px;\n                        background-color: rgba(0, 0, 0, 0.1);\n                        display: flex;\n                        justify-content: center;\n                }\n        .login-form-navigation{\n                display: flex;\n                flex-direction: column;\n                align-items:center;\n        }\n        .login-form-navigation{\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n        } \n        .login-form-navigation a{\n                margin-right:0px;\n        }\n                .login-card {\n                        width: 80%;\n                        background-color: #fff;\n                        display: flex;\n                        flex-direction: column;\n                        justify-content: left;\n                        align-items: left;\n                        border-radius: 10px;\n                        padding: 20px;\n                }\n                .login-form input {\n                        height: 50px;\n                        margin-bottom: 10px;\n                        width: 90%;\n                        font-size: large;\n                        font-family: 'Poppins', sans-serif;\n                        font-weight: 100;\n                        padding-left: 20px;\n                        margin-top: 10px;\n                }\n                .login-card h1 {\n                        font-family: 'Poppins', sans-serif;\n                        font-weight: 520;\n                        margin:20px;\n                }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
